import {LocalModalDialog} from "../modal-dialog";
import {createFormData} from "../helpers/form-data-helper";
import {DAYS_IN_WEEK, DAYS_IN_YEAR, HOURS_IN_DAY, MINUTES_IN_HOUR, SECONDS_IN_MINUTE} from "../constants";
import axios from "../../axios-instance";

const EXPORT_TYPE_FFR = 'ffr'
const EXPORT_TYPE_DISK = 'disk'

const ftpsData = {
  ffr: null,
  disk: null
}

const initViewCredentialsLinks = (ftpsDialogs) => {
  document.querySelectorAll('.js-ftps-view-credentials').forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const isPasswordProtected = e.target.dataset.passwordProtected === '1';
      const exportId = e.target.dataset.id;
      if (isPasswordProtected) {
        const dialogData = {
          machineName: e.target.dataset.name
        };
        const dialogHtml = Handlebars.compile(atob(ftpsDialogs.passwordDialog))(dialogData)
        const passwordDialog = new LocalModalDialog({
          dialogData: dialogHtml
        });
        passwordDialog.getTemplate().then(dialog => {
          const submitButton = document.querySelector('.js-submit-password');
          submitButton.addEventListener('click', (e) => {
            e.preventDefault();
            const passwordInput = document.querySelector('.js-password-input');
            getCredentials(exportId, passwordInput.querySelector('input').value).then((response) => {
              if (!response.data.error) {
                passwordDialog.destroyModalBox();
                showCredentialsDialog(ftpsDialogs, response.data);
              }
              passwordInput.status='error';
            })
          });
        });
      } else {
        getCredentials(exportId).then((response) => {
          showCredentialsDialog(ftpsDialogs, response.data);
        })
      }
    });
  });
};

const initDiscardLinks = (ftpsDialogs) => {
  document.querySelectorAll('.js-ftps-discard').forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const exportId = e.target.dataset.id;
      const machineName = e.target.dataset.name;
      const exportType = e.target.dataset.type;
      const dialogData = {
        machineName: machineName,
        isExported: true
      };

      const dialogHtml = Handlebars.compile(atob(ftpsDialogs.discardDialog))(dialogData)
      const discardDialog = new LocalModalDialog({
        dialogData: dialogHtml
      });
      discardDialog.getTemplate().then(dialog => {
        const discardButton = document.querySelector('.js-ftps-discard-button');
        discardButton.addEventListener('click', (e) => {
          e.preventDefault();
          const discardingDialogData = {
            machineName: machineName,
            discarding: true,
          };
          discardDialog.destroyModalBox();
          const dialogHtml = Handlebars.compile(atob(ftpsDialogs.discardDialog))(discardingDialogData)
          const discardingDialog = new LocalModalDialog({
            dialogData: dialogHtml
          });
          discardingDialog.getTemplate().then(dialog => {
            axios.delete(`/ftps_export/discard/${exportId}`)
              .then((response) => {
                const finalDialogData = {
                  machineName: machineName
                }
                if (!response.data.error) {
                  finalDialogData.isDiscarded = true;
                  finalDialogData.discardText = response.data.message.text;
                } else {
                  finalDialogData.isFailed = true;
                  finalDialogData.failedText = response.data.message.text;
                  finalDialogData.failedInfo = response.data.message.info;
                }
                discardingDialog.destroyModalBox();
                const dialogHtml = Handlebars.compile(atob(ftpsDialogs.discardDialog))(finalDialogData)
                const discardFinalDialog = new LocalModalDialog({
                  dialogData: dialogHtml
                });
                discardFinalDialog.getTemplate().then(dialog => {
                  if (!response.data.error) {
                    if (exportType === EXPORT_TYPE_FFR) {
                      loadFfrExports(ftpsDialogs);
                    } else if (exportType === EXPORT_TYPE_DISK) {
                      loadDiskExports(ftpsDialogs);
                    }
                  }
                });
              });
          });
        });
      });
    });
  });
};

const getCredentials = (exportId, password = null) => {
  return axios.post(`/ftps_export/ftps_credentials`,
    createFormData({
      password: password,
      export_id: exportId
    })
  );
};

const showCredentialsDialog = (ftpsDialogs, dialogData) => {
  const dialogHtml = Handlebars.compile(atob(ftpsDialogs.credentialsDialog))(dialogData)
  const credentialsDialog = new LocalModalDialog({
    dialogData: dialogHtml
  });
  credentialsDialog.getTemplate().then(() => {
    const links = document.querySelectorAll('.input-link');
    links.forEach(link => {
      link.addEventListener('click', () => {
        const input = link.parentElement.querySelector('axs-input');
        const valueToCopy = input.value;
        navigator.clipboard.writeText(valueToCopy).then(() => {
        });
      });
    });
  });
};

const getFfrExports = (resellerId, clientId) => {
  return axios.get(`/dashboard_ftps_exports/get_ftps_ffr_records/${resellerId}/${clientId}`);
};

const getDiskExports = (resellerId, clientId) => {
  return axios.get(`/dashboard_ftps_exports/get_ftps_disk_records/${resellerId}/${clientId}`);
};

const loadFfrExports = (ftpsDialogs) => {
  const clientId = ftpsDialogs.clientId || 0;
  const resellerId = ftpsDialogs.resellerId || 0;
  getFfrExports(resellerId, clientId).then((response) => {
    ftpsData.ffr = response.data;
    renderFtpsExports(ftpsDialogs);
    updateExpiration(ftpsDialogs, 0, clientId > 0);
  });
};

const loadDiskExports = (ftpsDialogs) => {
  const clientId = ftpsDialogs.clientId || 0;
  const resellerId = ftpsDialogs.resellerId || 0;
  getDiskExports(resellerId, clientId).then((response) => {
    ftpsData.disk = response.data;
    renderFtpsExports(ftpsDialogs);
    updateExpiration(ftpsDialogs, 0, clientId > 0);
  });
};

const getCurrentTab = (ftpsDialogs, isClientPage) => {
  if (ftpsDialogs.isAxcient) {
    return isClientPage ? '#clients-tab' : '#resellers-tab';
  } else if (ftpsDialogs.isReseller) {
    return isClientPage ? '#clients-tab' : '#reseller-dashboard-tab';
  } else {
    return '';
  }
};

const renderFtpsExports = (ftpsDialogs) => {
  // skip if data is not loaded yet
  if (!ftpsData.ffr || !ftpsData.disk) {
    return;
  }
  const clientId = ftpsDialogs.clientId || 0;
  const tab = getCurrentTab(ftpsDialogs, clientId);
  // Remove current records
  const currentDiskExports = document.querySelector(`${tab} .feed-table-interest .ftps-disk-exports`);
  const currentFfrExports = document.querySelector(`${tab} .feed-table-interest .ftps-cloud-ffr`);
  if (currentDiskExports) {
    currentDiskExports.remove();
  }
  if (currentFfrExports) {
    currentFfrExports.remove();
  }

  const nothingRecent = document.querySelector(`${tab} .feed-table-interest .nothingrecent`);
  if (nothingRecent) {
    nothingRecent.remove();
  }

  const showClientColumn = clientId === 0;
  const activitiesTable = document.querySelector(`${tab} .feed-table-interest`);
  if (!activitiesTable) {
    return;
  }

  if (ftpsData.ffr.length > 0) {
    const renderedFfrHtml = Handlebars.compile(atob(ftpsDialogs.ffrTemplate))({records: ftpsData.ffr, showClientColumn: showClientColumn});
    activitiesTable.insertAdjacentHTML('afterbegin', renderedFfrHtml);
  }

  if (ftpsData.disk.length > 0) {
    const renderedDiskHtml = Handlebars.compile(atob(ftpsDialogs.diskTemplate))({records: ftpsData.disk, showClientColumn: showClientColumn});
    activitiesTable.insertAdjacentHTML('afterbegin', renderedDiskHtml);
  }

  const activities = document.querySelectorAll(`${tab} .feed-table-interest .feed-row`);
  if (activities.length === 0) {
    const renderedNoActivitiesHtml = Handlebars.compile(atob(ftpsDialogs.noActivitiesTemplate))();
    activitiesTable.insertAdjacentHTML('afterbegin', renderedNoActivitiesHtml);

  } else {
    // Expand the "Activities of Interest" section to make it
    // visible if at least one activity is available in the list.
    const activitiesHeader = document.querySelector(`${tab} .collapsible-feed .header.pointer`);
    if (activitiesHeader) {
      activitiesHeader.classList.add('expanded');
    }

    activitiesTable.style.display = '';
  }

  initViewCredentialsLinks(ftpsDialogs);
  initDiscardLinks(ftpsDialogs);
};

const updateExpiration = (ftpsDialogs, wait = 0, isClientPage = false) => {
  const seconds = 1000;
  const minutes = seconds * SECONDS_IN_MINUTE;
  const hours = minutes * MINUTES_IN_HOUR;
  const days = hours * HOURS_IN_DAY;
  const weeks = days * DAYS_IN_WEEK;
  const years = days * DAYS_IN_YEAR;

  let waitTime = years;

  clearTimeout(window.ftps_export_counter);
  window.ftps_export_counter = setTimeout(function() {
    let all_expired = true;
    const clientId = ftpsDialogs.clientId || 0;
    const tab = getCurrentTab(ftpsDialogs, clientId);

    const cells = document.querySelectorAll(`${tab} .ftps-cloud-ffr .activitytable [data-expire], ${tab} .ftps-disk-exports .activitytable [data-expire]`);
    if (cells.length === 0) {
      updateExpiration(seconds);
    }
    cells.forEach((element) => {
      const expireTs = parseInt(element.getAttribute('data-expire'));
      if (expireTs) {
        const now = new Date();
        const expirationDate = new Date(expireTs * seconds);
        const timeToExpire = expirationDate - now;
        let timeLeft = '';

        if (timeToExpire > 0) {
          const numSeconds = Math.floor((timeToExpire % minutes) / seconds);
          const numMinutes = Math.floor((timeToExpire % hours) / minutes);
          const numHours = Math.floor((timeToExpire % days) / hours);
          const numDays = Math.floor((timeToExpire % weeks) / days);
          const numWeeks = Math.floor((timeToExpire % years) / weeks);
          const numYears = Math.floor(timeToExpire / years);

          let entitiesCount = 0;
          wait = days;

          all_expired = false;

          if (numYears) {
            timeLeft += numYears + ' ' + (numYears > 1 ? _years : _year) + ' ';
            entitiesCount++;
          }
          if (numWeeks) {
            timeLeft += numWeeks + ' ' + (numWeeks > 1 ? _weeks : _week) + ' ';
            entitiesCount++;
          }
          if ((numDays || numWeeks) && entitiesCount < 2) {
            timeLeft += numDays + ' ' + (numDays > 1 ? _days : _day) + ' ';
            wait = hours;
            entitiesCount++;
          }
          if ((numHours || numDays) && entitiesCount < 2) {
            timeLeft += numHours + ' ' + (numHours > 1 ? _hours : _hour) + ' ';
            wait = minutes;
            entitiesCount++;
          }
          if ((numMinutes || numHours) && entitiesCount < 2) {
            timeLeft += numMinutes + ' ' + _min + ' ';
            wait = minutes;
            entitiesCount++;
          }
          if (numMinutes > 4) {
            // don't show seconds if expiration more that in 5 minutes
            wait = minutes;
            entitiesCount++;
          }
          if (entitiesCount < 2) {
            timeLeft += numSeconds + ' ' + _sec;
            wait = seconds;
          }
        } else {
          timeLeft = _ftps_discarding;
          const row = element.closest('tr');
          if (row) {
            const discardLink = row.querySelector('.js-ftps-discard');
            if (discardLink) {
              discardLink.style.display = "none";
              element.innerText = timeLeft;
            }
          }
        }
        waitTime = Math.min(waitTime, wait);
        element.innerText = timeLeft;
        element.setAttribute('data-axTooltip', timeLeft);
      }
    });

    if (!all_expired) {
      updateExpiration(waitTime);
    }
  }, wait);
};

export {loadFfrExports, loadDiskExports};
